import { SVGProps } from 'react';
import { useStyledTheme } from '../../..';

type TooltipInfoIconProps = SVGProps<SVGSVGElement> & {
  iconInverted?: boolean;
}

export function TooltipInfoIcon({ iconInverted = false, ...rest }: TooltipInfoIconProps) {
  const theme = useStyledTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      fill="none"
      {...rest}
    >
      <path
        fill={iconInverted ? theme.colours.neutral[2] : theme.colours.neutral[4]}
        d="M7 1.667a5.333 5.333 0 1 0 0 10.666A5.333 5.333 0 0 0 7 1.667ZM.333 7a6.667 6.667 0 1 1 13.334 0A6.667 6.667 0 0 1 .333 7Z"
      />
      <path
        fill={iconInverted ? theme.colours.neutral[2] : theme.colours.neutral[4]}
        d="M7 5.667c.368 0 .667.298.667.666v4a.667.667 0 1 1-1.333 0v-4c0-.368.298-.666.666-.666ZM8 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      />
    </svg>
  );
}
